import { Network } from './network';

type TransactionMapping = Record<
  Network,
  (txId: string) => { apiUrl: string; explorerUrl: string; explorerUrlAddress: string }
>;

export type UrlType = 'apiUrl' | 'explorerUrl' | 'explorerUrlAddress';

export const transactionUrl: TransactionMapping = {
  mainnet: (txId: string) => ({
    apiUrl: `https://stacks-node-api.mainnet.stacks.co/extended/v1/tx/${txId}`,
    explorerUrl: `https://explorer.stacks.co/txid/${txId}?chain=mainnet`,
    explorerUrlAddress: `https://explorer.stacks.co/address/${txId}?chain=mainnet`,
  }),
  testnet: (txId: string) => ({
    apiUrl: `https://stacks-node-api.testnet.stacks.co/extended/v1/tx/${txId}`,
    explorerUrl: `https://explorer.stacks.co/txid/${txId}?chain=testnet`,
    explorerUrlAddress: `https://explorer.stacks.co/address/${txId}?chain=testnet`,
  }),
  mocknet: (txId: string) => ({
    apiUrl: `http://localhost:3999/extended/v1/tx/${txId}`,
    explorerUrl: `http://localhost:8000/txid/${txId}?chain=mainnet`,
    explorerUrlAddress: `http://localhost:8000/address/${txId}?chain=mainnet`,
  }),
};
